/**
 * @generated SignedSource<<fb67f7c59ad55e10e93f4b425925bc0d>>
 * @relayHash fd81f231087cf7200e9dc6564487d4ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type WatchDialogContentWatchContentMutation$variables = {
  id: string;
};
export type WatchDialogContentWatchContentMutation$data = {
  readonly watchContent: {
    readonly content: {
      readonly currentUserIsWatching: boolean;
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchDialogContentWatchContentMutation = {
  response: WatchDialogContentWatchContentMutation$data;
  variables: WatchDialogContentWatchContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "id"
          },
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          }
        ],
        "kind": "ObjectValue",
        "name": "watchContentInput"
      }
    ],
    "concreteType": "WatchContentPayload",
    "kind": "LinkedField",
    "name": "watchContent",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "currentUserIsWatching"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchDialogContentWatchContentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchDialogContentWatchContentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd81f231087cf7200e9dc6564487d4ac",
    "id": "8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286",
    "metadata": {},
    "name": "WatchDialogContentWatchContentMutation",
    "operationKind": "mutation",
    "text": "mutation WatchDialogContentWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id,currentUser:true}){content{id,currentUserIsWatching}}}"
  }
};
})();

(node as any).hash = "c3af78be0429c7abdaa087ce8a337162";

export default node;
